import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import {
  LuArrowRight,
  LuClock,
  LuEyeOff,
  LuGlobe,
  LuLock,
  LuServer,
  LuShield,
} from 'react-icons/lu';

import { BEDROCK_URL, DPA_URL, SECURITY_URL } from '../constants';

const SIGNALS = [
  { key: 'encrypted', Icon: LuLock, href: SECURITY_URL },
  { key: 'noTraining', Icon: LuEyeOff, href: DPA_URL },
  { key: 'bedrock', Icon: LuServer, href: BEDROCK_URL },
  { key: 'soc2', Icon: LuShield, href: SECURITY_URL },
  { key: 'soc2Type2', Icon: LuClock, href: SECURITY_URL },
  { key: 'gdpr', Icon: LuGlobe, href: DPA_URL },
] as const;

const stylesheet = {
  root: 'relative z-10 mt-6 max-w-[430px] border-t border-white/15 pt-[22px]',
  lead: 'mb-[15px] flex items-center justify-between gap-3',
  leadTitle: 'text-[13px] font-bold tracking-[0.01em] text-white',
  leadLink:
    'inline-flex items-center gap-[5px] text-[12.5px] font-semibold text-white/80 hover:text-white transition-colors',
  signals: 'flex flex-wrap gap-x-[10px] gap-y-[9px]',
  sig: 'inline-flex items-center gap-2 rounded-semantic border border-white/20 bg-white/10 px-3 py-2 text-[12.5px] font-medium leading-none text-white/90 no-underline transition-colors hover:border-white/40 hover:bg-white/20 hover:text-white',
  sigIcon: 'shrink-0 text-[#8ff0c8]',
};

export function AuthTrustBar(): ReactNode {
  const { t } = useTranslation();
  return (
    <div className={stylesheet.root}>
      <div className={stylesheet.lead}>
        <span className={stylesheet.leadTitle}>
          {t('auth.security.trustHeading')}
        </span>
        <a
          className={stylesheet.leadLink}
          href={SECURITY_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('auth.security.commitmentsLink')}
          <LuArrowRight aria-hidden={true} />
        </a>
      </div>
      <div className={stylesheet.signals}>
        {SIGNALS.map(({ key, Icon, href }) => (
          <a
            key={key}
            className={stylesheet.sig}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon className={stylesheet.sigIcon} aria-hidden={true} />
            {t(`auth.security.${key}`)}
          </a>
        ))}
      </div>
    </div>
  );
}
